<template>
    <v-container >
        <h2 class="my-text-black" style="text-align: center;">Padrón por turnos</h2>
        <v-row justify="center">
            <v-col cols="12" md="6" sm="6">
                <v-divider id="divider"></v-divider>
            </v-col>
        </v-row>
        <v-row justify="center">
            <v-col cols="12" md="6" sm="6">
                <v-btn 
                    id="boton-verde" 
                    block 
                    :disabled="!estaLogueado()"
                >Cargar paciente</v-btn>
            </v-col>
        </v-row>
        <v-row justify="center">
            <v-col cols="12" md="6" sm="6">
                <v-btn 
                    id="boton-verde" 
                    block
                    :disabled="!estaLogueado()"
                >Ver pacientes con turnos</v-btn>
            </v-col>
        </v-row>
        <v-row justify="center">
            <v-col cols="12" md="6" sm="6">
                <v-btn 
                    id="boton-verde" 
                    block
                    :disabled="!estaLogueado()"
                ><v-icon icon="mdi mdi-arrow-left"></v-icon> Cambiar facturador</v-btn>
            </v-col>
        </v-row>
        <v-container class="d-flex justify-center align-center">
          <Loader v-if="cargando"></Loader>
        </v-container>
    </v-container>
    <AlertComponent
      :title="alertTitle"
      :text="alertText"
      :alertType="alertType"
      :showAlert="showAlert"
      @close="showAlert = false"
    />
</template>

<style src="../assets/general.css"></style>

<script>
    export default{
        data() {
            return {
                cargando:false,
                showAlert:false,
                alertTitle: '',
                alertText: '',
                alertType: '',
            }
        },
        methods:{
            estaLogueado(){
                return this.$store.getters.isAuthenticated;
            }
        }
    }
</script>